<template>
  <span
    class="mr-3 hover:text-teal-700 cursor-pointer"
    @click="getExcelFile"
    v-tooltip="i18n.tooltip"
  >
    <font-awesome-icon icon="spinner" spin v-if="loading" />
    <font-awesome-icon icon="file-excel" fixed-width v-else></font-awesome-icon>
    <span class="text-sm" v-text="i18n.button"></span>
  </span>
</template>

<script>
import axios from "axios";
import { handleAxiosError } from "@/boot/functions";

export default {
  props: ["endpoint", "i18n"],
  components: {},
  mixins: [],
  data: function () {
    return {
      loading: false,
    };
  },
  methods: {
    getExcelFile() {
      this.loading = true;
      axios
        .get(this.endpoint, { responseType: "blob" })
        .then((response) => {
          this.loading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            this.getBackendFilename(response.request)
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(handleAxiosError)
        .then(() => {
          this.loading = false;
        });
    },
    // TODO : add this to a mixin when we have another export component
    getBackendFilename(request) {
      let filename = "MyRanchProjects.xlsx";
      let disposition = request.getResponseHeader("Content-Disposition");
      if (disposition && disposition.indexOf("attachment") !== -1) {
        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        let matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }

      return filename;
    },
  },
  computed: {},
  mounted() {},
};
</script>
